import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useGivenCans, useUpdateGivenCans } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { useProducts } from "../../products/hooks";

type IUpdateGivenCans = {
  id: string;
};

export const UpdateGivenCans: React.FC = () => {
  const { id } = useParams<IUpdateGivenCans>();
  const navigate = useNavigate();
  const { data: productsData } = useProducts({ where: {}, limit: 100, offset: 0 });

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useGivenCans(+id!);
  const { form, submit, loading } = useUpdateGivenCans({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("La distribution a été modifiée avec succès");
    },
  });

  useEffect(() => {
    if (data?.givenCans?.ok && data?.givenCans?.result) {
      const { result } = data.givenCans;
      form.setValue("customerId", result.customerId);
      form.setValue("quantity", result.quantity);
      form.setValue("comment", result.comment);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  const givenCans = data?.givenCans?.result;

  return (
    <>
      <Header
        title="Distribution gratuite"
        subtitle={givenCans ? `#${givenCans.id}` : ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/given-cans`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier une distribution" />
          <div className="w-full">
            <div className="flex flex-wrap gap-3">
              <Select label="Produit" className="w-full" value={givenCans?.productId ?? ""} disabled>
                <option value="">-</option>
                {productsData?.products?.results?.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name}
                  </option>
                ))}
              </Select>
              <CustomerSelectSearch form={form} name="customerId" label="Client (optionnel)" />
              <Input
                label="Quantité"
                type="number"
                className="w-full"
                {...form.register("quantity", { valueAsNumber: true })}
              />
              <Textarea
                label="Commentaire"
                className="w-full"
                {...form.register("comment")}
              />
            </div>
            <div className="w-full mt-4">
              <Button onClick={submit} loading={loading} disabled={loading}>
                Valider
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
